var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"toolbar-secundaria-contenido bs-2",attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12","align-self":"center"}},[_c('tipos',{attrs:{"Controlador":_vm.Controlador}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }